import { useEffect, useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

import analytics from '../analytics';

const langs = ['en', 'de', 'fr'];

const Navbar = () => {
  const { lang, setLang, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close drawer on resize back to desktop
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 900) setMenuOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Prevent body scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    analytics.navClick(id);
  };

  const navItems = ['about', 'gallery', 'activities', 'amenities', 'booking'];

  return (
    <>
      <nav className={`navbar${scrolled ? ' scrolled' : ''}`} aria-label="Main navigation">
        <span className="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          Alphubel <span>Peak 1</span>
        </span>
        <ul>
          {navItems.map((s) => (
            <li key={s}>
              <a href={`#${s}`} onClick={(e) => { e.preventDefault(); scrollTo(s); }}>
                {t.nav[s]}
              </a>
            </li>
          ))}
        </ul>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
          <div className="lang-switcher">
            {langs.map((l) => (
              <button key={l} className={l === lang ? 'active' : ''} onClick={() => { setLang(l); analytics.languageSwitch(l); }}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <a href="#booking" className="nav-cta nav-cta--desktop" onClick={(e) => { e.preventDefault(); window.dispatchEvent(new CustomEvent('open-booking-widget')); analytics.ctaClick('nav_book_now'); }}>
            {t.hero.cta}
          </a>
          <button
            className={`nav-hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="nav-drawer" role="dialog" aria-label="Mobile navigation">
          <ul>
            {navItems.map((s) => (
              <li key={s}>
                <a href={`#${s}`} onClick={(e) => { e.preventDefault(); scrollTo(s); }}>
                  {t.nav[s]}
                </a>
              </li>
            ))}
          </ul>
          <div className="nav-drawer-lang">
            {langs.map((l) => (
              <button key={l} className={l === lang ? 'active' : ''} onClick={() => { setLang(l); analytics.languageSwitch(l); setMenuOpen(false); }}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <a
            href="#booking"
            className="btn-primary nav-drawer-cta"
            onClick={(e) => { e.preventDefault(); setMenuOpen(false); window.dispatchEvent(new CustomEvent('open-booking-widget')); analytics.ctaClick('nav_book_now'); }}
          >
            {t.hero.cta}
          </a>
        </div>
      )}
    </>
  );
};

export default Navbar;
